import * as React from 'react';
import {Card} from "../components/Card";
import {useEffect} from "react";
import {stepOneSchema, stepTwoSchema} from "../schemas/formSchema";
import {useInputFields} from "../contexts/InputFields";
import {useNavigate} from "react-router-dom";

type Props = {

};
export const Success = (props: Props) => {
    const {formData} = useInputFields();
    const navigate = useNavigate();

    useEffect(() => {
        const stepOne = stepOneSchema.safeParse(formData);
        if (!stepOne.success) {
            navigate('/', {replace: true});
        }

        const stepTwo = stepTwoSchema.safeParse(formData);
        if (!stepTwo.success) {
            navigate('/passo-2', {replace: true});
        }
    }, []);

    return (
        <div className="w-full">
            <Card>
                <div className="w-full px-6 pb-24 md:px-0">
                    <div className="title pr-16">Queremos te desejar PARABÉNS!</div>
                    <div className="text-14 text-primary">
                        Você acabou de dar um grande passo para vender online.
                    </div>
                    <div className="separator-line mt-6 mb-4" />
                    <div className="text-14 text-tertiary leading-4">
                        Agora, com o Conecta Venda você está <b>cada vez mais próximo de digitalizar o seu negócio.</b> Conte conosco nessa nova jornada!<br/>
                        <br/>
                        E para você começar da melhor maneira possível, <b>vamos te instruir para a criação do seu primeiro
                        catálogo online.</b><br/>
                        <br/>
                        Primeiro, você precisa acessar nossa área exclusiva para assinantes, onde terá acesso a todas as funcionalidades da nossa plataforma:
                    </div>
                    <a
                        href="https://www.painel.conectavenda.com.br/"
                        className="btn w-full my-4 block text-center"
                    >
                        Acessar minha conta
                    </a>
                    <div className="text-14 text-tertiary leading-4">
                        Depois, lá dentro, <b>terá o passo a passo para a criação de seus produtos e catálogos, tudo de
                        forma prática e rápida.</b><br/>
                        <br/>
                        Se tiver qualquer dúvida, entre em contato com nosso atendimento, <a className="underline text-primary" href="https://api.whatsapp.com/send?phone=555434434563&text=Ol%C3%A1,%20acabei%20de%20contratar%20o%20Conecta%20Venda.%20" target="_blank">clicando aqui</a>, que estamos a disposição para te ajudar. <br/>
                        <br/>
                        <b>Boas vendas!</b>
                    </div>
                </div>
            </Card>
        </div>
    );
};